import * as React from 'react';
import * as styles from './PagSeguroIcon.scss';

export default (props: any) => (
  <img
    className={styles.pagSeguroLogo}
    src="https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-pagSeguro-new.svg"
    style={props.style}
  />
);



// WEBPACK FOOTER //
// ./components/icons/PagSeguroIcon/PagSeguroIcon.tsx